
export class FightIdentFF {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "Fight Ident FF";
    this.scene = "Fight Ident FF";
    this.data = [];
    this.page = 9010;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "1101";
      }).value = (options?.game?.home_fighter?.last_name?.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1201";
      }).value = (options?.game?.away_fighter?.last_name?.toUpperCase()  || "");


      xml.payload.field.find((item) => {
        return item.attr.name === "1112";
      }).value = (options?.game?.home_fighter?.style.toUpperCase() || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1212";
      }).value = (options?.game?.away_fighter?.style.toUpperCase() || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1215";
      }).value =
        options?.game?.competition?.flag_path +
        (options.game?.away_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1207";
      }).value =
        options?.game?.competition?.fighter_full_path +
        (options.game?.away_fighter?.image || "");

              xml.payload.field.find((item) => {
        return item.attr.name === "1115";
      }).value =
        options?.game?.competition?.flag_path +
        (options.game?.home_fighter?.nationality?.code || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "1107";
      }).value =
        options?.game?.competition?.fighter_full_path +
        (options.game?.home_fighter?.image || "");

      
      xml.payload.field.find((item) => {
        return item.attr.name === "1001";
      }).value = options?.game?.title || "";

      

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
